import schemas from 'components/forms/fields/definedSchemas';
import Joi from 'joi';

const fields = {
    applicant_delivery_address_street: {
        ...schemas.textRequired,
        label: 'Delivery Address (Required)',
        section: 'Delivery Information',
        autocomplete: 'address-line1',
    },
    applicant_delivery_address_city: {
        ...schemas.textRequired,
        label: 'Delivery Address City (Required)',
        section: 'Delivery Information',
        autocomplete: 'address-level2',
    },
    applicant_delivery_address_state: {
        ...schemas.states,
        label: 'Delivery Address State (Required)',
        section: 'Delivery Information',
        autocomplete: 'address-level1',
    },
    applicant_delivery_address_zip: {
        ...schemas.textRequired,
        label: 'Delivery Address Zip (Required)',
        section: 'Delivery Information',
        autocomplete: 'postal-code',
        validation: Joi.string()
            // zip code parsing. accepts either 12345 or 12345-6789
            .regex(new RegExp(/^[0-9]{5}(?:-[0-9]{4})?$/))
            .required()
            .messages({
                'string.pattern.base':
                    'Please enter 5 or 9 digit zip code like 98765 or 98765-4321',
            }),
    },
};

export default fields;
